import React from 'react';
import PackageCard from '../components/PackageCard';
import BeforeYouBook from '../components/BeforeYouBook';
import { Helmet } from 'react-helmet-async';
const IntensiveLessonsPage = () => {
  const intensivePackages = [{
    title: '10 Hour Intensive',
    price: '£480',
    originalPrice: '£500',
    description: '£48 per hour - Perfect for those with some driving experience who need to quickly prepare for their test.',
    features: ['Save £20 on standard pricing', 'Concentrated learning', 'Quick skill development', 'Ideal for refresher training'],
    saving: '£20',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '20 Hour Intensive',
    price: '£910',
    originalPrice: '£1000',
    description: '£45.50 per hour - Complete your training in a condensed timeframe with our popular mid-range intensive course.',
    features: ['Save £90 on standard pricing', 'Accelerated learning programme', 'Comprehensive skill coverage', 'Ideal for quick test preparation'],
    saving: '£90',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '34 Hour Intensive',
    price: '£1,496',
    originalPrice: '£1,700',
    description: '£44 per hour - Our comprehensive course for those with little to no driving experience.',
    features: ['Save £204 on standard pricing', 'Complete beginner to test-ready', 'All driving skills covered', 'Theory test preparation included'],
    popular: true,
    saving: '£204',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '40 Hour Intensive',
    price: '£1,720',
    originalPrice: '£2,000',
    description: '£43 per hour - Our most comprehensive intensive course for complete beginners.',
    features: ['Save £280 on standard pricing', 'Complete driver training', 'Fast-track to test readiness', 'Additional practice on challenging skills'],
    saving: '£280',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }];
  return <div className="bg-white" data-id="element-1447" data-mp="1ksghxacfdbd8">
      <Helmet data-id="element-1448" data-mp="1ktrthwc43new">
        <title data-id="element-1449" data-mp="1kvcg8zs6q227">Intensive Driving Courses Northampton | Pass Quickly</title>
        <meta name="description" content="Fast-track your driving journey with intensive driving courses in Northampton. Flexible packages from 10 to 40 hours. Book online today." data-id="element-1450" data-mp="28jcgcqbdz4tg" />
        <meta name="keywords" content="intensive driving courses Northampton, crash driving courses Northampton, fast pass driving lessons Northampton, quick driving test Northampton" data-id="element-1451" data-mp="1ysr80b5wulxc" />
      </Helmet>
      <div className="container mx-auto px-4 py-12" data-id="element-1452" data-mp="2w8ev9qemyjk9">
        <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1453" data-mp="2w96qv188ghaj">
          Intensive Driving Courses
        </h1>
        <h2 className="sr-only" data-id="element-1454" data-mp="krv6t9uupdzb">Fast Pass Driving Courses Northampton</h2>
        <h2 className="sr-only" data-id="element-1455" data-mp="ftbix3wp5s4b">Accelerated Driving Lessons Northampton</h2>
        <h2 className="sr-only" data-id="element-1456" data-mp="uizhhxdhucoc">
          Pass Your Driving Test Quickly in Northampton
        </h2>
        <div className="mb-8" data-id="element-1457" data-mp="pjmmuqgds1b7">
          <p className="text-gray-700" data-id="element-1458" data-mp="plh7e3nqprer">
            Our intensive driving courses are designed for those who want to
            pass their test quickly. These condensed programmes offer the same
            high-quality instruction as our standard lessons but in a more
            concentrated format.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-1459" data-mp="at5mzbje9jgf">
          {intensivePackages.map((pkg, index) => <PackageCard key={index} {...pkg} data-id="element-1460" data-mp="1ma5dc1m6lo7t" data-mpi={index} />)}
        </div>
        <div className="bg-gray-50 rounded-lg p-8 mb-12" data-id="element-1461" data-mp="1mci2ozu9r0uw">
          <h2 className="text-2xl font-bold mb-4" data-id="element-1462" data-mp="1i7s9xjuwq2e7">
            Is an Intensive Course Right for You?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1463" data-mp="2dkkytmbp09xs">
            <div data-id="element-1464" data-mp="2hjtskr6qg7tc">
              <h3 className="text-xl font-semibold mb-3" data-id="element-1465" data-mp="2hld9mk07qmw6">Benefits</h3>
              <ul className="space-y-2" data-id="element-1466" data-mp="2mj5d8ba7zxg7">
                <li className="flex" data-id="element-1467" data-mp="2mi3q38fxjki4">
                  <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1468" data-mp="2rirrmo1sbjql">
                    ✓
                  </div>
                  <div data-id="element-1469" data-mp="2wie0klakydtl">Faster route to passing your test</div>
                </li>
                <li className="flex" data-id="element-1470" data-mp="30j7qfk7l22p4">
                  <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1471" data-mp="30i50pflzy6as">
                    ✓
                  </div>
                  <div data-id="element-1472" data-mp="35ay3hxxwn4k8">
                    Consistent learning without long gaps between lessons
                  </div>
                </li>
                <li className="flex" data-id="element-1473" data-mp="3f8vtapvex9ey">
                  <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1474" data-mp="3f9x54wk95zxq">
                    ✓
                  </div>
                  <div data-id="element-1475" data-mp="3k5chtl6ixpsk">Cost savings compared to individual lessons</div>
                </li>
                <li className="flex" data-id="element-1476" data-mp="18lekrenhferq">
                  <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1477" data-mp="13la8k0tlx67b">
                    ✓
                  </div>
                  <div data-id="element-1478" data-mp="ymyvzibxghle">Dedicated instructor throughout your course</div>
                </li>
                <li className="flex" data-id="element-1479" data-mp="tnmc96gcrqn1">
                  <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1480" data-mp="tonkz49wc11l">
                    ✓
                  </div>
                  <div data-id="element-1481" data-mp="1mbi49xuz8udh">Structured learning plan with clear progression</div>
                </li>
              </ul>
            </div>
            <div data-id="element-1482" data-mp="1hk03pawv8vt1">
              <h3 className="text-xl font-semibold mb-3" data-id="element-1483" data-mp="1hjgvilx0pls7">Considerations</h3>
              <ul className="space-y-2" data-id="element-1484" data-mp="1cmgpgb064j13">
                <li className="flex" data-id="element-1485" data-mp="1clf1j5y2021y">
                  <div className="mr-4 text-amber-500" aria-hidden="true" data-id="element-1486" data-mp="2a0sxmu9zzmhl">
                    !
                  </div>
                  <div data-id="element-1487" data-mp="25a43t8auidfa">Requires commitment to a condensed schedule</div>
                </li>
                <li className="flex" data-id="element-1488" data-mp="3caibqs33rig">
                  <div className="mr-4 text-amber-500" aria-hidden="true" data-id="element-1489" data-mp="3dc0ef7ipe9o">
                    !
                  </div>
                  <div data-id="element-1490" data-mp="8dq11c6shlxo">Can be mentally and physically demanding</div>
                </li>
                <li className="flex" data-id="element-1491" data-mp="3pqamksxnhmlg">
                  <div className="mr-4 text-amber-500" aria-hidden="true" data-id="element-1492" data-mp="3uqybn92bjtd1">
                    !
                  </div>
                  <div data-id="element-1493" data-mp="3gqniu0hg84p8">
                    Need to be available for multiple hours over consecutive
                    days
                  </div>
                </li>
                <li className="flex" data-id="element-1494" data-mp="36tsl3jt028c0">
                  <div className="mr-4 text-amber-500" aria-hidden="true" data-id="element-1495" data-mp="36uu9epz10rbo">
                    !
                  </div>
                  <div data-id="element-1496" data-mp="3bsvrp8omomm3">
                    Best suited for those who can absorb information quickly
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mb-12" data-id="element-1497" data-mp="19z68qhk0woi9">
          <h2 className="text-2xl font-bold mb-4" data-id="element-1498" data-mp="2uj1khu89vnf6">
            How Our Intensive Courses Work
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1499" data-mp="2pkqanjhz9cwy">
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1500" data-mp="2pidmuppjg8bz">
              <h3 className="text-xl font-semibold mb-3" data-id="element-1501" data-mp="349w9358zqz3s">1. Assessment</h3>
              <p className="text-gray-700" data-id="element-1502" data-mp="2zi4hqsi0gpcl">
                We begin with an assessment of your current driving ability to
                tailor the course to your specific needs and determine the
                appropriate number of hours.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1503" data-mp="3n7yw5ehzalyy">
              <h3 className="text-xl font-semibold mb-3" data-id="element-1504" data-mp="3n7gq5q5iktdu">2. Scheduling</h3>
              <p className="text-gray-700" data-id="element-1505" data-mp="3i9xaqmx2yakb">
                We'll work with you to create a schedule that fits your
                availability, typically involving daily sessions of 2-4 hours
                over 1-2 weeks.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1506" data-mp="121p0gdlkkyhf">
              <h3 className="text-xl font-semibold mb-3" data-id="element-1507" data-mp="1215ulv9720jr">3. Completion</h3>
              <p className="text-gray-700" data-id="element-1508" data-mp="1700ez1mt7x5z">
                The course concludes with a mock test to ensure you're fully
                prepared, followed by assistance in booking your practical
                driving test.
              </p>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-1509" data-mp="j3cut1tva6ql">
          <h2 className="text-2xl font-bold mb-4" data-id="element-1510" data-mp="j4e6n8ipix9d">
            Ready to Fast-Track Your Learning?
          </h2>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-1511" data-mp="o40gr938nxdy">
            Book your intensive course today and get test-ready in weeks, not
            months.
          </p>
          <div className="max-w-3xl mx-auto mb-8" data-id="element-1512" data-mp="x3dvag67zc5j">
            <BeforeYouBook data-id="element-1513" data-mp="24gfubhpxbaef" />
          </div>
          <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-block transition-colors" aria-label="Book your intensive driving course in Northampton" data-id="element-1514" data-mp="24fe76evmuxgc">
            Book Now
          </a>
        </div>
      </div>
    </div>;
};
export default IntensiveLessonsPage;